import React, { useEffect, useRef } from 'react';
import { useField } from '@unform/core';
import Select from 'react-select';
import PropTypes from 'prop-types';

import { InputWrapper } from '../..';

export default function SelectInput({ name, label, width, ...rest }) {
  const selectRef = useRef();
  const { fieldName, registerField, error } = useField(name);

  useEffect(() => {
    registerField({
      name: fieldName,
      ref: selectRef.current,
      // path: 'select.state.value',
      getValue: (ref) => {
        if (rest.isMulti) {
          if (!ref.state.value) {
            return [];
          }
          return ref.state.value.map((option) => option.value);
        }

        if (!ref.state.value) {
          return '';
        }

        return ref.state.value.value;
      },
      setValue: (ref, value) => {
        ref.select.setValue(value || null);
      },
    });
  }, [fieldName, registerField, rest.isMulti]);

  return (
    <InputWrapper width={width} flexDirection="column">
      {label && <label htmlFor={fieldName}>{label}</label>}

      <Select
        ref={selectRef}
        className={error ? 'has-error' : ''}
        noOptionsMessage={() => 'Nenhuma opção encontrada'}
        placeholder="Seleciona uma opção"
        isOptionDisabled={(option) => option.disabled}
        {...rest}
      />

      {error && <span className="error">{error}</span>}
    </InputWrapper>
  );
}

SelectInput.propTypes = {
  name: PropTypes.string.isRequired,
  label: PropTypes.string,
  width: PropTypes.number,
};

SelectInput.defaultProps = {
  label: null,
  width: null,
};
